import { type VKAuthSuccessResult, Config, Connect } from '@vkontakte/superappkit';
import { oid } from 'reactApp/appHelpers/featuresHelpers/features/oid';
import { vKAppID, vkConnectDomain, vkLoginDomain, vkOauthDomain } from 'reactApp/appHelpers/featuresHelpers/features/vkidSdk';

import { sendXray } from './ga';

const initVkIdConfig = () => {
    Config.init({
        appId: vKAppID,
        loginDomain: vkLoginDomain,
        oauthDomain: vkOauthDomain,
        connectDomain: vkConnectDomain,
        appSettings: {
            service_groups: {
                oid,
            },
        },
    });
};

export const doSilentVkAuth = async () => {
    try {
        initVkIdConfig();
        const data = await Connect.silentAuth();
        return data?.payload;
    } catch (err) {
        sendXray('vkid_silent_auth');
        return null;
    }
};

export const doVisibleVkAuth = async () => {
    try {
        initVkIdConfig();
        const data = (await Connect.userVisibleAuth()) as VKAuthSuccessResult;
        return data?.payload;
    } catch (err) {
        sendXray('visible_silent_auth');
        return null;
    }
};
